import React from "react";
import Card from "react-bootstrap/Card";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p>
            Hello World! I'm{" "}
            <span className="purple">Jenina Angelin</span>.
            <br />
            I'm a <span className="purple">Data Engineer</span> at{" "}
            <a
              href="https://zeb.co/"
              target="_blank"
              rel="noreferrer"
              className="purple"
              style={{ textDecoration: "none" }}
            >
              zeb
            </a>
            , Chennai, India.
            <br />
            I hold a Bachelor's degree in{" "}
            <span className="purple">
              Artificial Intelligence and Data Science
            </span>
            .
            <br />
            <br />
            I work with{" "}
            <span className="purple">
              data engineering, analytics, and intelligent systems
            </span>
            , with a focus on turning complex data into reliable and
            meaningful solutions.
            <br />
            <br />
            Beyond engineering, I enjoy{" "}
            <span className="purple">
              technical writing, research, and building projects
            </span>{" "}
            that allow me to explore emerging technologies and solve
            real-world problems.
          </p>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;